import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = () => ({
  Legend: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: '0',
    flexShrink: '100',
    flexWrap: 'wrap',
    alignItems: 'center',
    margin: '5px',
    overflow: 'hidden',
    position: 'relative',
    fontSize: '0.9em',
    '& div': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  ColorPreview: {
    width: '20px',
    height: '20px',
    margin: '5px',
    marginLeft: '20px',
    minWidth: '10px',
    borderRadius: '2px',
  },
  MarkerPreview: {
    width: '6px',
    height: '6px',
    minWidth: '6px',
    borderRadius: '2px',
    margin: '5px',
    marginLeft: '20px',
  },
  label: {
    fontSize: '0.8em',
    whiteSpace: 'nowrap',
  },
});

export function Legend(props) {
  const { classes, theme } = props;
  return (
    <div className={classes.Legend}>
      <div>
        <div
          className={classes.ColorPreview}
          style={{
            backgroundColor: theme.lifeline.palette.wild,
          }}
        />
        <Typography variant="body1" className={classes.label}>
          {'Wild'}
        </Typography>
      </div>
      <div>
        <div
          className={classes.ColorPreview}
          style={{
            backgroundColor: theme.lifeline.palette.captive,
          }}
        />
        <Typography variant="body1" className={classes.label}>
          {'In captivity'}
        </Typography>
      </div>
      <div>
        <div
          className={classes.ColorPreview}
          style={{
            backgroundColor: theme.lifeline.palette.logbook,
          }}
        />
        <Typography variant="body1" className={classes.label}>
          {'Logbook available'}
        </Typography>
      </div>
      <div>
        <div
          className={classes.MarkerPreview}
          style={{
            backgroundColor: theme.lifeline.palette.markers.measure,
          }}
        />
        <Typography variant="body1" className={classes.label}>
          {'Measured'}
        </Typography>
      </div>
      <div>
        <div
          className={classes.MarkerPreview}
          style={{
            backgroundColor: theme.lifeline.palette.markers.logbook,
          }}
        />
        <Typography variant="body1" className={classes.label}>
          {'Logbook recorded'}
        </Typography>
      </div>
    </div>
  );
}

Legend.propTypes = {
  classes: PropTypes.shape().isRequired,
  theme: PropTypes.shape().isRequired,
};

export default withTheme()(withStyles(styles)(Legend));



// WEBPACK FOOTER //
// ./src/components/lifeline/Controls/Legend.jsx